import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dialog-hero" }
const _hoisted_2 = { class: "hero-icon-wrap" }
const _hoisted_3 = { class: "current-info" }
const _hoisted_4 = { class: "info-value" }
const _hoisted_5 = { class: "info-value" }

import { ref, watch } from "vue";
import { ElMessage } from "element-plus";
import { RefreshRight, Check } from "@element-plus/icons-vue";
import { replaceHardwareApi } from "@/api/cert/certBatchApi";


export default /*@__PURE__*/_defineComponent({
  __name: 'ReplaceHardwareDialog',
  props: {
    modelValue: { type: Boolean },
    endpointId: {},
    currentDeviceId: {},
    currentName: {}
  },
  emits: ["update:modelValue", "success"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const visible = ref(props.modelValue);
const newDeviceId = ref("");
const newName = ref("");
const remark = ref("");
const submitting = ref(false);

watch(
  () => props.modelValue,
  (val) => {
    visible.value = val;
    if (val) {
      newDeviceId.value = "";
      // 名称默认填入原名称，留空则不修改
      newName.value = props.currentName || "";
      remark.value = "";
    }
  }
);
watch(visible, (val) => emit("update:modelValue", val));

const handleClose = () => {
  newDeviceId.value = "";
  newName.value = "";
  remark.value = "";
};

const handleSubmit = async () => {
  if (!newDeviceId.value.trim()) {
    ElMessage.warning("请输入新终端编号");
    return;
  }

  submitting.value = true;
  try {
    // 名称留空时不传该字段，服务端只更新非空字段
    await replaceHardwareApi(
      props.endpointId,
      newDeviceId.value.trim(),
      // 仅在填了名称时传，名称为空 = 不修改
      newName.value.trim() || undefined,
      remark.value.trim() || undefined
    );
    ElMessage.success(
      "硬件更换成功，新终端上线后请点击【迁移设备】恢复设备数据采集"
    );
    emit("success");
    visible.value = false;
  } catch (e: any) {
    ElMessage.error(e.message || "更换失败");
  } finally {
    submitting.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: visible.value,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((visible).value = $event)),
    title: "更换硬件",
    width: "520px",
    "close-on-click-modal": false,
    class: "replace-dialog",
    onClose: handleClose
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        size: "large",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (visible.value = false))
      }, {
        default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
          _createTextVNode("取消", -1)
        ]))]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        type: "primary",
        size: "large",
        loading: submitting.value,
        class: "submit-btn",
        onClick: handleSubmit
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [
              _createVNode(_unref(Check))
            ]),
            _: 1
          }),
          _cache[10] || (_cache[10] = _createElementVNode("span", null, "确认更换", -1))
        ]),
        _: 1
      }, 8, ["loading"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_icon, {
            size: 22,
            color: "#fff"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(RefreshRight))
            ]),
            _: 1
          })
        ]),
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "hero-text" }, [
          _createElementVNode("h3", null, "更换终端硬件"),
          _createElementVNode("p", null, "设备板子损坏时更换，原 endpointId 和绑船关系保持不变")
        ], -1))
      ]),
      _createElementVNode("div", _hoisted_3, [
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "info-label" }, "当前终端编号", -1)),
        _createElementVNode("div", _hoisted_4, _toDisplayString(__props.currentDeviceId || "(无)"), 1),
        _cache[7] || (_cache[7] = _createElementVNode("div", {
          class: "info-label",
          style: {"margin-top":"12px"}
        }, "当前终端名称", -1)),
        _createElementVNode("div", _hoisted_5, _toDisplayString(__props.currentName || "(无)"), 1)
      ]),
      _createVNode(_component_el_form, {
        "label-position": "top",
        class: "replace-form"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "新终端编号 (deviceId)",
            required: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: newDeviceId.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newDeviceId).value = $event)),
                placeholder: "如 IMEI860123045678902",
                clearable: ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "新终端名称" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: newName.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newName).value = $event)),
                placeholder: "留空则不修改原名称",
                clearable: ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "备注" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: remark.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((remark).value = $event)),
                type: "textarea",
                rows: 2,
                placeholder: "可选，如：板子进水损坏"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_alert, {
        type: "warning",
        closable: false,
        class: "warn-alert"
      }, {
        title: _withCtx(() => [...(_cache[8] || (_cache[8] = [
          _createElementVNode("div", { class: "warn-text" }, [
            _createTextVNode(" · 旧终端将被踢线，无法再连接"),
            _createElementVNode("br"),
            _createTextVNode(" · 新终端需烧录证书，连接后自动上线"),
            _createElementVNode("br"),
            _createTextVNode(" · 设备绑船关系和历史数据保持不变"),
            _createElementVNode("br"),
            _createTextVNode(" · 新终端上线后，请点击【迁移设备】恢复设备数据采集"),
            _createElementVNode("br"),
            _createElementVNode("span", { class: "warn-sub" }, "（船舶运营协议出厂已预置，无需迁移）")
          ], -1)
        ]))]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})